<template>
  <div class="int-created-return-exchange-container">
    <el-form
      ref="searchForm"
      :inline="true"
      class="searchBoxLine"
      :model="searchForm"
    >
      <el-form-item label="项目名称:" clearable>
        <el-input
          v-model.trim="searchForm.projectName"
          maxlength="30"
          placeholder="请输入项目名称"
        />
      </el-form-item>
      <el-form-item label="合同编号:" clearable>
        <el-input
          v-model.trim="searchForm.contractNum"
          maxlength="20"
          placeholder="请输入合同编号"
        />
      </el-form-item>
      <el-form-item label="代理商名称:">
        <el-input
          v-model.trim="searchForm.distributorName"
          maxlength="30"
          placeholder="请输入代理商名称"
        />
      </el-form-item>
      <el-form-item label="最终客户:">
        <el-input
          v-model.trim="searchForm.finalCustomer"
          maxlength="30"
          placeholder="请输入最终客户名称"
        />
      </el-form-item>
      <el-form-item label="合同时间:">
        <div class="rj-flex" style="width:260px;">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startFinalProcessingTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div class="int-created-return-exchange-search-form-date">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endFinalProcessingTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="CRM编码:">
        <el-input
          v-model.trim="searchForm.crmAccountCode"
          maxlength="30"
          placeholder="请输入CRM编码"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          :loading="tableLoading"
          @click="searchCilck"
        >
          搜索
        </el-button>
        <el-button
          type="default"
          @click="resetForm"
        >
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <!-- 列表部分 -->
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="distributorName"
          label="代理商名称"
          align="left"
        />
        <el-table-column
          prop="finalCustomer"
          label="最终客户"
          align="left"
        />
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="left"
        />
        <el-table-column
          prop="contractNum"
          label="合同编号"
          align="left"
        />
        <el-table-column
          prop="crmAccountCode"
          label="CRM编码"
          align="left"
        >
          <template v-slot="{ row }">
            <span v-if="row.crmAccountCode">{{ row.crmAccountCode }}</span>
            <span v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="合同时间"
          align="left"
        />
        <el-table-column
          prop="date"
          label="操作"
          width="180"
          align="left"
          fixed="right"
        >
          <template v-slot="{ row }">
            <div>
              <el-button type="text" @click="returnOrExchange(row)">
                退换货申请
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="int-created-return-exchange-table-pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <!-- 退换货申请dialog组件 -->
    <ApplicationExchangeDialog ref="showExchangeRef" />
  </div>
</template>
<script type="es6">
import { getSalesIntOrdersContractDataList } from '@/API/international.js';
import ApplicationExchangeDialog from '@/views/business/components/ApplicationExchangeDialog.vue';
export default {
  data () {
    return {
      searchForm: {
        projectName: '', // 项目名称
        contractNum: '', // 合同编号
        distributorName: '', // 代理商名称
        finalCustomer: '', // 最终客户
        crmAccountCode: '', // CRM编码
        startFinalProcessingTime: '', // 合同时间,起止时间
        endFinalProcessingTime: '' // 合同时间, 截止时间
      },
      tableLoading: false,
      tableData: [], // 列表数据
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  components: {
    ApplicationExchangeDialog
  },
  methods: {
    // 搜索方法
    searchCilck () {
      this.page.currentPage = 1;
      this.doSearch();
    },

    // 表单搜索
    doSearch () {
      this.tableLoading = true;
      let parmas = {
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      getSalesIntOrdersContractDataList(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {

      });
      this.tableLoading = false;
    },
    // 重置表单
    resetForm () {
      this.searchForm = {
        projectName: '', // 项目名称
        contractNum: '', // 合同编号
        distributorName: '', // 代理商名称
        finalCustomer: '', // 最终客户
        crmAccountCode: '', // CRM编码
        startFinalProcessingTime: '', // 合同时间,起止时间
        endFinalProcessingTime: '' // 合同时间, 截止时间
      };
      this.page.currentPage = 1;
      this.doSearch();
    },
    // 改变每页条数 当前页回到第一页
    handerSizeChange (val) {
      this.page.currentPage = 1;
      this.doSearch();
    },
    // 改变当前页
    handerCurrentChange (val) {
      this.doSearch();
    },
    // 国际退换货申请
    returnOrExchange (row) {
      this.$refs.showExchangeRef.showExchangeDialog(row);
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
<style lang="scss" scoped>
.int-created-return-exchange-container{
  // 搜索部分,开始截止时间
  .int-created-return-exchange-search-form-date{
    display: inline-block;
    width: 10px;
    text-align: center;
  }
  // 列表部分, 分页样式
  .int-created-return-exchange-table-pagination{
    text-align: right;
    margin-top: 10px
  }
}
</style>
